export default __webpack_public_path__ + "static/media/saUSDT.84be4d1c.svg";